import { createShelfHelperShelvesKey } from 'constants/queryCacheKeys';
import { getShelves } from 'domain/shelf-helper';
import { useQuery } from 'react-query';

export const useShelfHelperShelves = () => useQuery({
    queryKey: createShelfHelperShelvesKey(),
    queryFn: () => getShelves(),
});
